var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63641 21H5.45456V11.59L0 7.43848V19.3394C0 20.2569 0.732281 21.0001 1.63641 21.0001V21Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 21H22.3636C23.2677 21 24 20.2568 24 19.3394V7.43848L18.5454 11.59V21Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5454 4.39405V11.59L24 7.43847V5.22437C24 3.17215 21.6914 2.00005 20.0727 3.23166L18.5454 4.39405Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.45459 11.5899V4.39404L12 9.37585L18.5455 4.39404V11.5899L12 16.5717L5.45459 11.5899Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5.22437V7.43847L5.45456 11.59V4.39406L3.92728 3.23166C2.30859 2.00005 0 3.17215 0 5.22428V5.22437Z",
    fill: "#C5221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.847fc968381d5a1419d6b8ee918edf03.svg";
export { ForwardRef as ReactComponent };